import React from 'react';

import cx from 'classnames';
import { Arrow, ToggleLayer } from 'react-laag';

import Dropdown from 'components/shared/Dropdown';
import Icon from 'components/shared/Icon';
import ThreeDots from 'components/shared/Icon/icons/ThreeDots';

import styles from './index.module.css';

function TableMenu({ isFixed = false, children, closeOnInsideClick, placementParams, renderCell, iconClassName }) {
  return (
    <ToggleLayer
      renderLayer={({ isOpen, layerProps, arrowStyle, layerSide, close }) =>
        isOpen && (
          <div
            ref={layerProps.ref}
            className="layer"
            style={{
              ...layerProps.style,
              zIndex: '9',
            }}
          >
            <Dropdown
              type="tooltip"
              onClick={() => {
                if (closeOnInsideClick) {
                  close();
                }
              }}
            >
              {typeof children === 'function' ? children({ close }) : children}
            </Dropdown>

            <Arrow
              style={{ ...arrowStyle, zIndex: '21' }}
              layerSide={layerSide}
              borderWidth={1}
              borderColor="rgba(0, 0, 0, 0.04)"
              backgroundColor="#fff"
              angle={40}
              roundness={0.5}
              size={12}
            />
          </div>
        )
      }
      fixed={isFixed}
      placement={{
        anchor: 'RIGHT_BOTTOM',
        autoAdjust: true,
        triggerOffset: 10,
        ...placementParams,
      }}
      closeOnOutsideClick
    >
      {({ triggerRef, toggle }) => {
        if (renderCell) {
          return renderCell({
            triggerRef,
            toggle,
            className: cx(styles.icon, iconClassName),
            icon: <Icon component={ThreeDots} anchorRef={triggerRef} />,
          });
        }

        return (
          <td className={styles.icon} onClick={toggle}>
            <Icon component={ThreeDots} anchorRef={triggerRef} className={iconClassName} />
          </td>
        );
      }}
    </ToggleLayer>
  );
}

export default TableMenu;
